export default "__VITE_ASSET__DwlAHB$4__"